import { render, staticRenderFns } from "./faq-category-list.vue?vue&type=template&id=ecb8d382&"
import script from "./faq-category-list.vue?vue&type=script&lang=js&"
export * from "./faq-category-list.vue?vue&type=script&lang=js&"
import style0 from "./faq-category-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports